import { uuid } from 'vue-uuid';

export default {
  getId() {
    if (window.appAnonymousId) {
      return window.appAnonymousId;
    }
    let anonymousUid = localStorage.getItem('riseup.anonymousUid');
    if (!anonymousUid) {
      anonymousUid = `anon-${uuid.v4()}`;
      localStorage.setItem('riseup.anonymousUid', anonymousUid);
    }
    return anonymousUid;
  },
};
